<template>
    <div >
        <!--<div class="head">-->
            <!--<weitap :shuju="shuju" :Tapchecked="Tapchecked"></weitap>-->
        <!--</div>-->
        <div class="bodybox">
            <p class="hu_1"><span class="xinzenghuiyuan_1" style="border-color:#8CBB77">&nbsp;会员详情</span></p>
            <el-row style="padding: 10px;background:#f1f1f1 ">
                <el-col :span="6" style="padding-right: 30px;display: flex">

                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 姓名</div>
                    <el-input v-model="name1"  size="middle"></el-input>

                </el-col>

                <el-col :span="6" style="padding-right: 30px;display: flex">

                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 别名</div>
                    <el-input v-model="name1" size="middle"></el-input>

                </el-col>
                <el-col :span="6" style="padding-right: 30px;display: flex">

                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 出生日期</div>
                    <el-date-picker
                            v-model="date1"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>

                </el-col>
                <el-col :span="6" style="padding-right: 30px;display: flex">

                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 会员卡号</div>
                    <el-input v-model="name1" size="middle"></el-input>

                </el-col>

            </el-row>


            <el-row style="padding: 10px; background:#f1f1f1 ">
                <el-col :span="6" style="padding-right: 30px;display: flex">

                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 性别</div>
                    <div style="width: 100%;padding-top: 10px;padding-left: 10px">
                        <el-radio v-model="sex" label="1">男</el-radio>
                        <el-radio v-model="sex" label="2" style="margin-left: 15px">女</el-radio>
                    </div>
                </el-col>

                <el-col :span="6" style="padding-right: 30px;display: flex">
                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 来源</div>
                    <el-select v-model="laiyuan" placeholder="请选择" style="width: 100%">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :span="6" style="padding-right: 30px;display: flex">
                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 彩单人</div>
                    <el-select v-model="laiyuan" placeholder="请选择" style="width: 100%">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>


            </el-row>

            <p class="hu_1"><span class="xinzenghuiyuan_1" style="border-color:#8CBB77">&nbsp;家长联系方式</span></p>


            <el-row style="padding: 10px;background:#f1f1f1 " v-for="(i,index) in dijige" :key="index">
                <el-col :span="6" style="padding-right: 30px;display: flex">
                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 关系</div>

                    <el-select v-model="guanxi[index]" placeholder="请选择" style="width: 100%">
                        <el-option
                                v-for="item in options2"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :span="6" style="padding-right: 30px;display: flex">
                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 姓名</div>
                    <el-input v-model="name1" size="middle"></el-input>
                </el-col>

                <el-col :span="6" style="padding-right: 30px;display: flex">
                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 联系电话</div>
                    <el-input v-model="name1" size="middle"></el-input>
                </el-col>
                <el-col :span="6" style="padding-right: 30px;">
                    <div style="height: 40px" class="jiahao" v-if="index<1">
                        <img class="jialx" @click="jialianx(dijige.length)" src="/static/qmsj/img/+.png" alt="">
                    </div>
                    <!--<div style="height: 40px" class="jiahao" v-if="index>=1">-->
                    <!--<images class="jialx"  @click="jianlianx(index)" src="/static/qmsj/images/tixing.png" alt="">-->
                    <!--</div>-->
                </el-col>

            </el-row>

            <p class="hu_1"><span class="xinzenghuiyuan_1" style="border-color:#8CBB77">&nbsp; 家庭住址</span></p>

            <el-row style="padding: 10px;background:#f1f1f1 ">
                <el-col :span="6" style="padding-right: 30px;display: flex">
                    <div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 地区</div>
                    <el-select v-model="shengm" placeholder="请选择" style="width: 100%">
                        <el-option
                                v-for="item in sheng"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                </el-col>
                <el-col :span="6" style="padding-right: 30px;display: flex">

                    <div class="inputlabel"></div>
                    <el-select v-model="shim" placeholder="请选择" style="width: 100%">
                        <el-option
                                v-for="item in shi"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                </el-col>
                <el-col :span="6" style="padding-right: 30px;display: flex">

                    <div class="inputlabel"></div>
                    <el-select v-model="qum" placeholder="请选择" style="width: 100%">
                        <el-option
                                v-for="item in qu"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                </el-col>
            </el-row>


            <el-row style="padding: 10px;background:#f1f1f1 ">
                <el-col :span="18" style="padding-right: 30px;display: flex">
                    <div class="inputlabel" style="width: 90px"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 地区</div>
                    <el-input style="width: 100%"
                              type="textarea"
                              :rows="3"
                              placeholder="请输入内容"
                              v-model="xiangdz">
                    </el-input>
                </el-col>
            </el-row>


        </div>
        <div>
            <div class="queBtnbox">
                <input class=" querentij" type="submit" value="确认修改">
            </div>


        </div>

    </div>
</template>

<script>
    import purBtn from '@/components/btn.vue'
    import weitap from '@/components/weitap'
    export default {
        components:{
            purBtn,
            weitap
        },

        data() {
            return {
                shuju:[
                    {lian:'huiyuan', neir:'会员列表'},
                    {lian:'huiyuanxin', neir:'新增会员'},
                    {lian:'huiyuanqianxin', neir:'签约续约'}
                ],
                Tapchecked:1,
                name1:'',
                date1:'',
                sex:'1',
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],

                options2: [{
                    value: '1',
                    label: '爸爸'
                },
                    {
                        value: '2',
                        label: '妈妈'
                    },
                    {
                        value: '3',
                        label: '爷爷'
                    },
                    {
                        value: '4',
                        label: '奶奶'
                    },
                    {
                        value: '5',
                        label: '其他'
                    }
                ],
                guanxi:[{g:'0'},{g:'0'},{g:'0'},{g:'0'},{g:'0'}],
                laiyuan: '',
                jiacon:1,
//            guanxijai: 1,
                dijige:[
                    0
                ],
                shengm:'',
                sheng:[
                    {
                        value: '1',
                        label: '河北'
                    },
                    {
                        value: '2',
                        label: '河南'
                    },
                ],
                shim:'',
                shi:[
                    {
                        value: '1',
                        label: '河北'
                    },
                    {
                        value: '2',
                        label: '河南'
                    },
                ],
                qum:'',
                qu:[
                    {
                        value: '1',
                        label: '河北'
                    },
                    {
                        value: '2',
                        label: '河南'
                    },
                ],
                xiangdz:'',
                user_id:'',
                token:''
            };
        },
        methods:{
            jump:function (d) {
                this.$router.push(d)

            },
            jialianx:function (index) {
                if(this.dijige.length<5){
                    console.log(this.dijige)
                    this.dijige.push(index)
                }
            },
            jianlianx:function (index) {
                console.log(this.dijige)
                this.dijige.splice(index-1, 1)
                console.log(this.dijige)

            },
        },
        mounted:function () {
            let self = this;
            self.user_id=this.$route.query.id;
            self.token=self.$cookies.get('token');
            console.log(self.user_id);
            console.log(self.token);
        }

    }
</script>

<style scoped>
    *{

        font-size: 14px;
    }
    .head{
        padding:10px  45px 0 ;
        display: flex;
        display:-webkit-flex;
        justify-content: space-between;
        border-bottom: 1px solid #bdb8e0;
    }
    .bodybox{
        padding-left: 45px;
        padding-right: 45px;
    }
    .xinzenghuiyuan_1 {
        width: 100%;
        height: 25px;
        display: block;
        font-size: 16px;
        border-left: 6px solid #8CBB77;
        margin-top: 12px;
        margin-bottom: 12px;
    }
    .inputlabel{
        width: 120px;
        line-height: 40px;
        text-align: right;
        margin-right:5px;
    }
    .jialx{
        width: 20px;
        height: 20px;
        margin-left: 10px;
        vertical-align: middle;
        cursor: pointer;
    }
    .jiahao{
        display: flex;
        display: -webkit-flex;
        align-items: center;
    }
    .queBtnbox{
        height: 80px;
        display: flex;
        display:-webkit-flex;
        justify-content: center;
        align-items: center;
    }
    .querentij {
        width: 129px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: rgb(255, 255, 255);
        display: block;
        font-size: 16px;
        cursor: pointer;
        box-shadow: rgb(248, 222, 199) 0px 5px 10px;
        background: rgb(253, 176, 106);
        margin: 30px auto 0px;
        border-radius: 16px;
        border-width: initial !important;
        border-style: none !important;
        border-color: initial !important;
        border-image: initial !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/huiyuan/huiyuanxiu.vue